const hasBoldStyle = (element) => {
  const { fontWeight } = element.style;

  return fontWeight.includes('bold') || fontWeight > 400;
};

export default hasBoldStyle;
